import { Directive, ElementRef, OnInit, Input, inject } from '@angular/core';
import { AuthService } from '../../core/auth/auth.service';

@Directive({
  selector: '[admRequiresFeatureRole]',
})
export class RequiresFeatureRoleDirective implements OnInit {
  private el = inject(ElementRef);
  private authService = inject(AuthService);

  @Input('admRequiresFeatureRole') permissions = '';

  ngOnInit() {
    if (!this.authService.hasRole(this.permissions)) {
      this.el.nativeElement.style.display = 'none';
    }
  }
}
